import { DOCUMENT } from '@angular/common';
import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { isNullOrUndefined } from '@shared/utils/utils';
import { QrCodeDialogComponent } from './shared/components';
import { TenantService } from './shared/services/tenant.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title: string;
  appLogo: string = "";
  qrIcon: string;
  uploadPlaceholder: string;
  langSelected = 'nl_BE';
  cookieValue = null;

  @ViewChild('viewer', { static: true }) private viewer: ElementRef;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private translate: TranslateService,
    private cookieService: CookieService,
    public dialog: MatDialog,
    private tenantService: TenantService,
    public router: Router) {

    this.cookieValue = this.cookieService.get('lang');

    // Handle old cookies from before switching to nl_BE and en_US
    if (this.cookieValue === 'nl') {
      this.cookieService.delete('lang');
      this.cookieValue = 'nl_BE';
    }
    if (this.cookieValue === 'en') {
      this.cookieService.delete('lang');
      this.cookieValue = 'en_US';
    }

    if (!isNullOrUndefined(this.cookieValue) && this.cookieValue !== '') {
      this.langSelected = this.cookieValue;
    } else {
      this.langSelected = 'nl_BE';
    }
    translate.setDefaultLang('nl_BE');
    translate.use(this.langSelected);

    this.cookieService.set('lang', this.langSelected, null, '/', null, true, 'None');
  }

  ngOnInit() {
    this.title = this.tenantService.getParameter("upload", "title");
    this.appLogo = this.tenantService.getParameter("upload", "logoImage");
    this.qrIcon = this.tenantService.getParameter("upload", "qrIconImage");
    this.uploadPlaceholder = this.tenantService.getParameter("upload", "uploadImage");
  }

  public changeLanguage(lang) {
    this.translate.use(lang);
    this.cookieService.set('lang', this.langSelected, null, '/', null, true, 'None');
    // refresh so that model descriptions get refetched in correct language
    const url = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([`/${url}`]);
    });
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(QrCodeDialogComponent, {
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  public checkIfMobile() {
    return window.navigator.userAgent.toLowerCase().includes("mobi");
  }

}
